import { useTrads } from "../../contexts/trads/useTrads";
import { getByPath, uniqid } from "../../tools/utils";
import type { SelectProps } from "../../types/Interface";
import type { FieldError } from "react-hook-form";



export function StatutPageSelectorBootstrap({name, label, registerOutput, errors}:SelectProps){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name) as FieldError[];
    const {translate}=useTrads();
    const statuts=['00_draft' , '01_published' , '02_refused' , '03_deleted'];
    return (
        <>
        <div className={ "form-floating " +  (errors[name] ? " is-invalid":'')}>
                <select className={"form-select "+ (errors[name]? " is-invalid":'')} id={id}
                 {...registerOutput} 
                >
                    <option value="">-----</option>
                    {statuts.map((value)=>
                       <option value={value} key={value}>{translate(value)}</option>
                    )}
                </select>
                <label className="form-label" htmlFor={id}>{label}</label>
                
        </div>
        {field_errors.length > 0 && <div className="invalid-feedback">{field_errors.map((error)=> 
                <p key={error.message} role="alert">{translate(error.message)}</p>)
            }</div>}
        </>
    );
}